import { useParams } from "react-router-dom";
import SingleProgramsPage from "../components/SingleProgramsPage/SingleProgramsPage";

const SingleProgramsDynamicPage = () => {
  const { id } = useParams();
  return <SingleProgramsPage pageId={id} />;
};

export default SingleProgramsDynamicPage;
